<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Dokumentasi Project" @back="back">
            <common-training-header :withUser="true" :user_hash="attendant" />
        </a-page-header>

        <a-card type="inner" size="small" style="margin-bottom: 24px">
            <a-skeleton :loading="loading" active>
                <a-table
                    :columns="columnsSk"
                    :dataSource="dataSk"
                    rowKey="id"
                    :pagination="false"
                    class="pcp-table"
                    bordered>

                    <template slot="title" slot-scope="currentPageData">
                        <strong>SK Organisasi</strong>
                    </template>

                    <div slot="decree_number" slot-scope="record" style="text-align: left">
                        {{ record.decree_number }}
                    </div>

                    <div slot="name" slot-scope="record" style="text-align: left">
                        {{ record.title }}
                    </div>

                    <div slot="decree_date" slot-scope="record" style="text-align: left">
                        {{ moment(record.decree_date).format('DD MMMM YYYY') }}
                    </div>

                    <div slot="description" slot-scope="record" style="text-align: left">
                        {{ record.description }}
                    </div>

                    <div slot="file" slot-scope="record">
                        <a-button type="link" size="small"
                            @click="download(record.attachment)">
                            <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                        </a-button>
                    </div>

                </a-table>
            </a-skeleton>
        </a-card>

        <a-card type="inner" size="small" style="margin-bottom: 24px">
            <a-table
                :columns="columnsCharter"
                :dataSource="dataCharter"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                class="pcp-table"
                bordered>

                <template slot="title" slot-scope="currentPageData">
                    <strong>Project Charter</strong>
                </template>

                <div slot="name" slot-scope="record" style="text-align: left">
                    {{ record.title }}
                </div>

                <div slot="sponsor" slot-scope="record" style="text-align: left">
                    {{ record.sponsor }}
                </div>

                <div slot="objective" slot-scope="record" style="text-align: left">
                    {{ record.objective }}
                </div>

                <div slot="area" slot-scope="record" style="text-align: left">
                    {{ record.scope_of_work }}
                </div>

                <div slot="action" slot-scope="record">
                    <a-space>
                        <a-tooltip title="View Charter">
                            <a-button
                                style="margin-left: 4px;"
                                size="small"
                                icon="eye"
                                @click="charter(record.id)"
                            />
                        </a-tooltip>
                    </a-space>
                </div>
            </a-table>
        </a-card>

        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table
                    :columns="columnsSteps"
                    :dataSource="dataSteps"
                    rowKey="id"
                    :pagination="false"
                    bordered
                    class="pcp-table"
                    :rowClassName="(r) => r.is_approved ? 'border-success' : 'border-warning'"
                >

                    <template slot="title" slot-scope="currentPageData">
                        <strong>Action Step</strong>
                    </template>

                    <div slot="step" slot-scope="record" style="text-align: left">
                        {{ record.title }}
                    </div>

                    <div slot="start" slot-scope="record" style="text-align: left">
                        {{ moment(record.plan_date_start).format('DD MMMM YYYY') }}
                    </div>

                    <div slot="done" slot-scope="record" style="text-align: left">
                        {{ moment(record.plan_date_end).format('DD MMMM YYYY') }}
                    </div>

                    <div slot="exe_date" slot-scope="record" style="text-align: left">
                        <div v-if="record.actual_date_end != null && record.status == 'done'">
                            {{ moment(record.actual_date_end).format('DD MMMM YYYY') }}
                        </div>
                    </div>

                    <div slot="gap" slot-scope="record">
                        <div v-if="record.actual_date_end != null && record.status == 'done'">
                            <a-tag color="#53ff4a" v-if="moment(record.actual_date_end, 'YYYY-MM-DD').diff(moment(record.plan_date_end, 'YYYY-MM-DD'), 'days') < 0">
                                <div style="color:black;width:20px">
                                    <strong>{{ moment(record.plan_date_end, 'YYYY-MM-DD').diff(moment(record.actual_date_end, 'YYYY-MM-DD'), 'days') }}</strong>
                                </div>
                            </a-tag>
                            <a-tag color="#f2eb18" v-else-if="moment(record.actual_date_end, 'YYYY-MM-DD').diff(moment(record.plan_date_end, 'YYYY-MM-DD'), 'days') == 0">
                                <div style="color:black;width:20px">
                                    <strong>{{ moment(record.actual_date_end, 'YYYY-MM-DD').diff(moment(record.plan_date_end, 'YYYY-MM-DD'), 'days') }}</strong>
                                </div>
                            </a-tag>
                            <a-tag color="#ff0000" v-else>
                                <div style="width:20px">
                                    <strong>{{ moment(record.actual_date_end, 'YYYY-MM-DD').diff(moment(record.plan_date_end, 'YYYY-MM-DD'), 'days') }}</strong>
                                </div>
                            </a-tag>
                        </div>
                    </div>

                    <div slot="progress" slot-scope="record">
                        {{ progress[record.status] }}
                    </div>

                    <div slot="percent" slot-scope="record" :style="'background-color: ' + prgColor(record.progress) ">
                        {{ record.progress }} %
                    </div>

                    <div slot="pic" slot-scope="record">
                        {{ record.pic }}
                    </div>

                    <div slot="photo" slot-scope="record">
                        <template v-for="item in record.files">
                            <div v-if="item.category == 'photo'">
                                <a-button type="link" size="small"
                                    @click="download(item.file_path)">
                                    <a-icon type="file-image" theme="twoTone" two-tone-color="#3452eb" /> Download
                                </a-button><br>
                            </div>
                        </template>
                    </div>

                    <div slot="report" slot-scope="record">
                        <template v-for="item in record.files">
                            <div v-if="item.category == 'document'">
                                <a-button type="link" size="small"
                                    @click="download(item.file_path)">
                                    <a-icon type="file" theme="twoTone" two-tone-color="#3452eb" /> Download
                                </a-button><br>
                            </div>
                        </template>
                    </div>

                    <div slot="action" slot-scope="record">
                        <a-tooltip title="Approve Step">
                            <a-button
                                style="margin-left: 4px;"
                                size="small"
                                type="primary"
                                icon="check-square"
                                :loading="processing"
                                @click="showConfirm(record.id, record.title)"
                                v-show="record.status === 'done' && record.is_approved === false && isMentor"
                            />
                        </a-tooltip>
                    </div>

                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
const progress = {
    not_done: 'Not Done',
    done: 'Done',
    progress: 'Progress'
}

const columnsSk = [
    {
		key: 'decree_number',
		title: 'Nomor SK',
        align: 'center',
		scopedSlots: {customRender: 'decree_number'},
	}, {
		key: 'name',
		title: 'Judul',
        align: 'center',
		scopedSlots: {customRender: 'name'},
	}, {
		key: 'decree_date',
		title: 'Tanggal',
        align: 'center',
		scopedSlots: {customRender: 'decree_date'}
	}, {
		key: 'description',
		title: 'Keterangan',
        align: 'center',
		scopedSlots: {customRender: 'description'}
	}, {
		key: 'file',
		title: 'File',
        align: 'center',
		scopedSlots: {customRender: 'file'}
	},
]

 const columnsCharter = [
    {
        key: 'name',
        title: 'Judul',
        align: 'center',
        scopedSlots: {customRender: 'name'},
    }, {
        key: 'sponsor',
        title: 'Sponsor',
        align: 'center',
        scopedSlots: {customRender: 'sponsor'}
    }, {
        key: 'objective',
        title: 'Objektif',
        align: 'center',
        scopedSlots: {customRender: 'objective'}
    }, {
        key: 'area',
        title: 'Lingkup Kerja',
        align: 'center',
        scopedSlots: {customRender: 'area'}
    }, {
        key: 'action',
        title: 'Action',
        align: 'center',
        scopedSlots: {customRender: 'action'}
    }
]

const columnsSteps = [
    {
		key: 'step',
		title: 'Action Step',
        align: 'center',
		scopedSlots: {customRender: 'step'},
	}, {
		key: 'planning',
		title: 'Perencanaan',
		scopedSlots: {customRender: 'planning'},
        children: [
            {
                key: 'start',
                title: 'Mulai',
                align: 'center',
                scopedSlots: {customRender: 'start'},
            },
            {
                key: 'done',
                title: 'Selesai',
                align: 'center',
                scopedSlots: {customRender: 'done'},
            },
        ]
	}, {
		key: 'exe_date',
		title: 'Selesai Pelaksanaan',
        align: 'center',
		scopedSlots: {customRender: 'exe_date'},
	}, {
		key: 'gap',
		title: 'Gap',
        align: 'center',
		scopedSlots: {customRender: 'gap'}
	}, {
		key: 'progress',
        colSpan: 2,
		title: 'Progress Status',
        align: 'center',
		scopedSlots: {customRender: 'progress'}
	}, {
		key: 'percent',
        colSpan: 0,
		title: '',
        align: 'center',
		scopedSlots: {customRender: 'percent'}
	}, {
		key: 'pic',
		title: 'PIC',
        align: 'center',
		scopedSlots: {customRender: 'pic'}
	}, {
		key: 'issues',
		title: 'Issues',
		scopedSlots: {customRender: 'issues'},
        children: [
            {
                key: 'photo',
                title: 'Foto',
                align: 'center',
                scopedSlots: {customRender: 'photo'},
            },
            {
                key: 'report',
                title: 'Laporan',
                align: 'center',
                scopedSlots: {customRender: 'report'},
            },
        ]
	}, {
		key: 'action',
		title: 'Action',
        align: 'center',
		scopedSlots: {customRender: 'action'}
	},
]

export default {
    props: {
        attendant: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            progress,
            columnsSk,
            columnsCharter,
            columnsSteps,
            loading: false,
            visible: false,
            processing: false,
            dataSk: [],
            dataCharter: [],
            dataSteps: [],
            id: '',
            title: '',
            items: {},
            params: {
                attendant: this.attendant
            }
        }
    },
    created() {
        this.getSk()
        this.getCharter()
        this.getSteps()
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        role(){
            return this.$laravel.roles[this.activeModule.module.identifier]
        },
        isMentor() {
            return this.role == 'mentor'
        },
    },
    methods: {
        getSk() {
            this.loading = true

            Object.assign(this.params, { outline: 'project_evaluation'})

            this.$http
                .get(this.routeUri('api.project-management.sk-organization.index'), {
                    params: this.params
                })
                .then(response => {
                    this.dataSk = response.data.decrees
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        getCharter() {
            this.loading = true;

            this.$http
                .get(this.routeUri("api.project-management.charter.index"), {
                    params: this.params
                })
                .then(response => this.dataCharter = response.data.charters)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        charter(id){
            this.params.charter = id

            window.location.href = this.routeUri('admin.project.charter') + '?' + this.$qs.stringify(this.params)
        },
        getSteps() {
            this.loading = true

            Object.assign(this.params, { outline: 'project_evaluation'})

            this.$http
                .get(this.routeUri('api.project-management.action-step.index')+ '?' + this.$qs.stringify(this.params))
                .then(response => {
                    this.dataSteps = response.data.steps.steps
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        prgColor(progress) {
            switch(progress){
                case 0:
                    return 'red;color: white'
                case 100:
                    return 'green;color: white'
                default: return 'yellow'
            }
        },
        back() {
            window.location.href = this.routeUri('admin.project.scoring.project_evaluation')
        },
        showConfirm(id, title) {
            var msg = 'Anda yakin akan melakukan approve?'

            this.id = id
            this.title = title

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.approved()
                },
                onCancel() {},
                class: 'test',
            });
        },
        approved(){
            this.processing = true

            let promise

            let params = {
                id: this.id,
                title: this.title,
                is_approved: 1
            }

            promise = this.$http.put(this.routeUri('api.project-management.action-step.update', {
                detail_step: this.id
            }), params)

            promise.then(response =>
                this.handleSuccessResponse(response.data)
            ).catch(error =>
                this.handleResponseError(error.response.data)
            ).finally(() => (this.processing = false))
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => window.location.reload(), 2000)
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    })
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                })
            }
        },
        download(url) {
            window.open(url, '_blank')
        },
    }
}
</script>
